import React from "react";
import { useThemeImageLayers } from "./useThemeImageLayers";

/*
  Обёртка шапки с двумя слоями картинки. Нужна там, где карточка рисуется
  внутри map и хук нельзя вызвать по месту (мобильная лента тарифов).
  Логика та же, что в TarifCard: при первом рендере монтируется только слой
  активной темы, второй доезжает в простое.

  className — класс обёртки, imgClassName — базовый класс слоя; тёмный слой
  получает его же плюс модификатор --dark. Дети (бейдж) рисуются поверх.
*/
const TopImageLayers = ({ light, dark, className, imgClassName, imgKey, children }) => {
  const { ready, primary, showLight, showDark } = useThemeImageLayers(light, dark);

  return (
    <div className={className + (ready ? " is-ready" : "")}>
      {showLight ? (
        <img
          key={imgKey ? `${imgKey}-light` : undefined}
          className={imgClassName}
          src={light}
          alt=""
          decoding="async"
          loading={primary === "light" ? "eager" : "lazy"}
        />
      ) : null}
      {showDark ? (
        <img
          key={imgKey ? `${imgKey}-dark` : undefined}
          className={`${imgClassName} ${imgClassName}--dark`}
          src={dark}
          alt=""
          decoding="async"
          loading={primary === "dark" ? "eager" : "lazy"}
        />
      ) : null}
      {children}
    </div>
  );
};

export default TopImageLayers;
